// Toast notification functionality for preview popup

export function showCopyToast() {
	// Remove existing toast if any
	$('.preview-popup__copy-toast').remove();

	const toastHtml = `
		<div class="preview-popup__copy-toast">
			<div class="preview-popup__copy-toast-content">
				<i class="bi bi-check-circle-fill"></i>
				<span>Link copied!</span>
			</div>
		</div>
	`;

	$('body').append(toastHtml);
	const $toast = $('.preview-popup__copy-toast');

	// Show toast with animation
	setTimeout(() => {
		$toast.addClass('preview-popup__copy-toast--visible');
	}, 10);

	// Hide and remove after delay
	setTimeout(() => {
		$toast.removeClass('preview-popup__copy-toast--visible');
		setTimeout(() => {
			$toast.remove();
		}, 300);
	}, 2000);
}
